define((require) => {
    "use strict";

    var ImprovedModel = require("shared/zbone/ImprovedModel");

    /**
     * Model for the "To" label in the recipients display field. Serves no function but to appear in the collection
     * rendered by the view.
     *
     * @class ShareRecipientToLabel
     * @constructor
     */
    return ImprovedModel.extend({});
});



// WEBPACK FOOTER //
// ./src/editor/ui/share/ShareRecipientToLabel.js